import { Button, DropMenu, EasyModal } from '@ui';
import React, { FC, useCallback, useEffect, useRef, useState } from 'react';

import useTranslation from '@app/hooks/use-translation';

import { formBaseButtonBlockStyles } from '@app/styles/base-styles';

import Icon from '@app/components/ui/icons';

import classNames from 'classnames';

import { generateColors } from '@app/utils/color-generate';

import { pieChartPalette } from '../../data/palette';

const PieChartPalette: FC<{
  onChange(palette: string[]): void;
  defaultValue: string[];
}> = ({ defaultValue, onChange }) => {
  const { t } = useTranslation('pages.chartPage');

  const [openedState, setOpenedState] = useState(false);
  const [localPaletteList, setPaletteList] = useState(pieChartPalette);
  const [customizationPalette, setPalette] = useState<{
    name: string;
    colors: string[];
  }>();
  const [colors, setColors] = useState<string[]>([]);

  function handleClickCopyPalette(paletteName: string) {
    const foundedPalette = pieChartPalette.find(({ name }) => paletteName === name);
    setPalette(foundedPalette);
    setColors(foundedPalette?.colors || []);
  }
  function handleClosePalette() {
    setPalette(undefined);
  }

  // d&d

  const dragItemIndex = useRef<number>(null);
  const dragOverIndex = useRef<number>(null);

  const handleDragStart = (elem: React.DragEvent<HTMLDivElement>, index: number) => {
    dragItemIndex.current = index;
  };

  const handleDragEnter = (index) => {
    dragOverIndex.current = index;

    if (
      dragItemIndex.current !== null &&
      dragOverIndex.current !== null &&
      dragItemIndex.current !== dragOverIndex.current
    ) {
      const newColors = [...colors];
      const draggedItem = newColors[dragItemIndex.current];

      newColors.splice(dragItemIndex.current, 1);
      newColors.splice(dragOverIndex.current, 0, draggedItem);

      setColors(newColors);

      dragItemIndex.current = dragOverIndex.current;
    }
  };

  const handleDragEnd = () => {
    dragItemIndex.current = null;
    dragOverIndex.current = null;
  };
  // d&d
  function handleSaveNewLocalPalette() {
    setPaletteList((prev) => {
      const res = [{ name: 'user' + prev.length + 1, colors: colors }, ...prev];
      return res;
    });
    handleClosePalette();
  }

  const handleGeneratePalette = useCallback(() => {
    const length = 9;
    const colors = generateColors(length, 'array');
    onChange(colors);
  }, [onChange]);

  const wasGenerated = useRef(defaultValue.length > 1);

  useEffect(() => {
    if (wasGenerated.current) return;
    handleGeneratePalette();
    wasGenerated.current = true;
  }, [handleGeneratePalette]);

  return (
    <div>
      <DropMenu
        vladSpecialProp
        dropSize={480}
        onChangeState={(val) => {
          setOpenedState(val);
        }}
        position="start"
        menu={localPaletteList.map((palette, paletteIndex) => ({
          key: palette.colors.join(','),
          isActive: String(palette.colors) === String(defaultValue),
          content: (
            <div
              key={paletteIndex + palette.name}
              className={`flex items-center justify-between w-full`}
            >
              <div className="text-[14px] text-1color relative">
                {/user/g.test(palette.name) ? (
                  <div className="absolute top-0 -left-[10px]">
                    <Icon name="SettingIcon" className="text-action" size={9} />
                  </div>
                ) : (
                  ''
                )}
                {t('palettes')} {paletteIndex + 1}
              </div>
              <div className="flex items-center gap-[12px] pr-1 relative">
                {palette.colors.map((color, indexColor) => (
                  <div
                    key={indexColor}
                    style={{ background: color }}
                    className="w-[22px] rounded-full overflow-hidden h-[22px] "
                  ></div>
                ))}
                <div
                  onClick={() => handleClickCopyPalette(palette.name)}
                  className="absolute top-0 -right-[10px]"
                >
                  <Icon size={11} className="text-action" name="CopyIcon" />
                </div>
              </div>
            </div>
          ),
        }))}
        onClick={(key) => {
          onChange(key.split(','));
        }}
      >
        <div className="flex items-center gap-[30px]">
          {/* <span className="text-action whitespace-nowrap text-[16px] font-[600] cursor-pointer">
            {t('palettes')}
          </span> */}
          <div className="flex items-center gap-[10px]">
            <div className="flex items-center gap-[12px]">
              {!defaultValue.length
                ? t('palette_not_selected')
                : defaultValue.map((color, indexColor) => (
                    <div
                      key={indexColor}
                      style={{ background: color }}
                      className="w-[22px] rounded-full overflow-hidden h-[22px]"
                    ></div>
                  ))}
            </div>
            <div className="flex items-center justify-center cursor-pointer">
              <div
                className={classNames(
                  'transform transition-transform duration-300',
                  openedState ? 'rotate-180' : 'rotate-0',
                )}
              >
                <Icon className="text-3color" name="ChevronDownV2Icon" size={14} />
              </div>
            </div>
          </div>
          <div
            data-drop-menu-ignore
            onClick={handleGeneratePalette}
            className="flex items-center gap-[10px] cursor-pointer hover:opacity-90"
          >
            <Icon size={15} className="text-action" name="RandomIcon" />
            <span className="text-action text-[15px] font-medium">{t('generate')}</span>
          </div>
        </div>
      </DropMenu>
      <EasyModal
        withoutContentPadding
        withoutFooter
        show={!!customizationPalette}
        onClose={handleClosePalette}
        variant="medium484"
        label="Кастомизировать порядок цветов"
      >
        <div className="relative">
          <div className="flex items-center  w-full justify-center p-4">
            {colors.map((color, index) => (
              <div
                key={index}
                draggable
                onDragStart={(elem) => handleDragStart(elem, index)}
                onDragEnter={() => handleDragEnter(index)}
                onDragEnd={handleDragEnd}
                className="p-2 "
              >
                <div
                  style={{ background: color }}
                  className="w-[25px] transition-all duration-300 rounded-full overflow-hidden h-[25px] border-[1px] border-solid border-1color"
                ></div>
              </div>
            ))}
          </div>
          <div className={formBaseButtonBlockStyles}>
            <Button onClick={handleSaveNewLocalPalette} label={t('palette_save')} />
            <Button onClick={handleClosePalette} label={t('palette_cancel')} />
          </div>
        </div>
      </EasyModal>
    </div>
  );
};

export default PieChartPalette;
